export default warehouseId => (
  window.open(`${process.env.API_LOCATION}/stocks/${warehouseId}/download/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/stock/downloadProduct.js